/**
 * Random UUID v4. `crypto.randomUUID` only exists in secure contexts (HTTPS or localhost), and a phone
 * opening a dev server over plain HTTP on the LAN is not one, so fall back to `getRandomValues`.
 */
export function uuid(): string {
  const c = globalThis.crypto;
  if (typeof c.randomUUID === 'function') return c.randomUUID();

  const bytes = new Uint8Array(16);
  c.getRandomValues(bytes);
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0'));
  return [
    hex.slice(0, 4).join(''),
    hex.slice(4, 6).join(''),
    hex.slice(6, 8).join(''),
    hex.slice(8, 10).join(''),
    hex.slice(10).join(''),
  ].join('-');
}

/** One key per user intent. Reuse the same key when retrying the same request. */
export const newIdempotencyKey = uuid;

export const newCorrelationId = uuid;
